import { yupResolver } from '@hookform/resolvers/yup';
import { IBatchesListDataTableRowFormMeta } from '@Modules/admin/integrationSettings/containers/forms/batchProcessing/batchesListDataTableRowMeta';
import { TBatchesListDataTableData } from '@Modules/admin/integrationSettings/containers/mixedHandlers/batchProcessing/BatchesListDataTableMeta';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput from '@Modules/core/components/form/CustomInput';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
  meta: IBatchesListDataTableRowFormMeta,
  data: TBatchesListDataTableData,
} & TFormUIProps;

export default React.forwardRef(function BatchesListDataTableRowFormUI(
  { onSubmit, isLoading, meta, data }: Props,
  ref: any
) {
  const submitBtnRef = React.useRef<HTMLButtonElement>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: data, resolver: yupResolver(meta.schema) });

  React.useImperativeHandle(ref, () => ({ submitBtnRef }));

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CC.SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} my={10}>
        {displayCustomInputs<IBatchesListDataTableRowFormMeta>(
          meta,
          register,
          errors,
          isLoading,
          [],
          [meta.executedFunction.name]
        )}
      </CC.SimpleGrid>
      <CustomFormControl
        isLoading={isLoading}
        isInvalid={!!errors[meta.executedFunction.name]}
        label={meta.executedFunction.label}
        w={'auto'}
      >
        <CustomInput
          hasError={errors[meta.executedFunction.name]}
          register={register(meta.executedFunction.name)}
          meta={meta.executedFunction}
        />
      </CustomFormControl>

      <CC.Button type={'submit'} ref={submitBtnRef} style={{ display: 'none' }}>
        Enregistrer
      </CC.Button>
    </CC.Box>
  );
});
